export default __webpack_public_path__ + "static/media/Mtimeseries.d53a4cda.png";